import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAPI } from '../../API';
import { ActionTypes, useAppDispatch, useAppState } from '../../Store';
import { useTranslation } from '../../Translation';
import SidebarNav from '../../Components/SidebarNav/SidebarNav';
import SettingSidebarNav from '../../Components/SidebarNav/SettingSidebarNav';
import useAuthenticated from '../Dashboard/useAuthenticated';
import GridTable from '../../Components/Table/GridTable';
import { usePaginations } from '../../Hooks/usePaginations';
import { TextInput } from '../../Components/Inputs/TextInput';
import { Button } from '../../Components/Buttons';
import { useRefresh } from '../../Hooks/useRefresh';
import Modal from '../../Components/Modal';
import { TrashIcon } from '@heroicons/react/24/outline';
export default function CustomFields() {


    const { translate, language, setLanguage } = useTranslation();
    const api = useAPI();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const appState = useAppState();
    const [customFields, setCustomFields] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedCustomField, setSelectedCustomField] = useState(null);
    const { refreshId, refresh } = useRefresh();

    const { isAuthenticated, pathAfterLogin } = useAuthenticated();

    const pagination = usePaginations();

    useEffect(() => {
        const fetchCustomFields = async () => {
            const response = await api.listCustomFields(pagination.page, pagination.pageSize);
            setCustomFields(response.data.customFields);
            pagination.setMetaData(response.data.meta);
        }
        fetchCustomFields();
    }, [pagination.page, refreshId]);

    const handleDelete = async (row) => {
        await api.deleteCustomField(row.id);
        refresh();
    }

    return (
        <>
         {/* Place the Modal outside the main container */}
         <Modal
                open={open}
                onClose={() => setOpen(false)}
                title={selectedCustomField ? translate('edit') : translate('create')}
                description={''}
                children={<CustomFieldModal refresh={refresh} setOpen={setOpen} customField={selectedCustomField} setSelectedCustomField={setSelectedCustomField} open={open} />}
            />
        <div className="flex min-h-full w-full">
            <SidebarNav currentPage="settings" contentPadding={false}>
                <div className='flex-1 flex-row h-full w-full'>
                    <SettingSidebarNav currentPage="customFields" />
                    <div className='flex-1 flex flex-col ml-24 md:ml-72'>
                        <div className='flex flex-col p-2 md:p-4 lg:p-6 w-full'>
                            <GridTable 
                                title={translate('setting.customFields')} 
                                description={translate('setting.customFields')} 
                                buttonText={translate('setting.customFields')} 
                                actions={[
                                    {
                                        text: translate('setting.customField.create'),
                                        action: () => {
                                            setSelectedCustomField(null);
                                            setOpen(true);
                                        }
                                    }
                                ]}
                                onRowClick={(item) => {
                                    setSelectedCustomField(item);
                                    setOpen(true);
                                }}
                                data={customFields} 
                                translationKey="setting.customField" 
                                columns={['label', 'variable_name']} 
                                pagination={pagination} 
                                dropdownGroups={[{
                                    options: [{
                                        label: translate('delete'),
                                        icon: <TrashIcon aria-hidden="true" className="mr-3 size-5 text-red-400 group-data-[focus]:text-gray-500" />,
                                        action: (row) => handleDelete(row)
                                    }]
                                }]}
                            />
                        </div>
                    </div>
                </div>
                
            </SidebarNav>
        </div>
        </>

    );
}


export const CustomFieldModal = ({ refresh, setOpen, customField, setSelectedCustomField, open , isCampaign = false}) => {

    const [variableName, setVariableName] = useState(customField ? customField.variable_name : '');
    const [label, setLabel] = useState(customField ? customField.label : '');
    const { translate } = useTranslation();
    const api = useAPI();

    const handleCreate = async () => {
        try {
            await api.createCustomField({
                variable_name: variableName,
                label,
            });
            refresh();

            setOpen(false);
            setVariableName('');
            setLabel('');
        } catch (error) {
            console.error(error);
        }
    }

    const handleUpdate = async () => {
        try {
            await api.updateCustomField(customField.id, {
                ...customField,
                variable_name: variableName,
                label,
            });
            refresh();
            setOpen(false);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (!open) {
            setVariableName('');
            setLabel('');
            setSelectedCustomField(null);
        }
    }, [open]);

    const buttonDisabled = !variableName || variableName.length === 0 || !label || label.length === 0;

    return (
        <div className="mt-4 overflow-visible">
            <TextInput id="label" name="label" label={translate('setting.customField.label')} placeholder={translate('setting.customField.label_placeholder')} value={label} onChange={(e) => setLabel(e.target.value)} />
            <div className="flex flex-col mt-4">
                <TextInput id="variable_name" name="variable_name" label={translate('setting.customField.variable_name')} placeholder={translate('setting.customField.variable_name_placeholder')} value={variableName} onChange={(e) => setVariableName(e.target.value)} />
            </div>
            
            <div className="flex justify-end mt-4">
                <Button disabled={buttonDisabled} onClick={customField ? handleUpdate : handleCreate}>{customField ? translate('update') : translate('create')}</Button>
            </div>
        </div>
    )
}